import {decomposeColor} from "@mui/system/colorManipulator";

export const isIOS = () => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return false;
        } else {
            return ua.indexOf('firefox') <= -1;
        }
    } else {
        return false;
    }
}

export const getFocusBackgroundColor = (theme: any) => {
    const opacity = 0.15;
    const decomposedPrimaryColor = decomposeColor(theme.palette.primary.main);
    return decomposedPrimaryColor.type === 'rgb'
        ? `rgba(${decomposedPrimaryColor.values.join(', ')}, ${opacity})`
        : theme.palette.primary.main;
}